
import { server } from '../engine/server'

var BuildingControllerIntegration = Class.create({
  	initialize: function() {
    },
    addController: function(ip, port, level, building_id, type, uuid, callback) {
        var url = "building/" + building_id + "/controllers/new";

        const params = {
            ip: ip,
            port: port,
            level: level,
            uuid: uuid,
            type: type
        };

		var data = server.getData(url, params, true, "POST");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
			callback(e);
		});
    },
});

export let buildingControllerIntegration = new BuildingControllerIntegration();


// WEBPACK FOOTER //
// app/core/controllers/BuildingControllerIntegration.js